/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 *
 *
 * https://medium.com/@thunderroid/angular-date-ago-pipe-minutes-hours-days-months-years-ago-c4b5efae5fe5
 */
import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe to visually display how long ago something occurred.
 */
@Pipe({
  name: 'dateAgo',
  pure: true,
  standalone: false,
})
export class DateAgoPipe implements PipeTransform {
  // TODO modify to handle translations
  transform(value: any, args?: any): any {
    if (value) {
      const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
      if (seconds < 29) // less than 30 seconds ago will show as 'Just now'
      { return 'Just now'; }
      const intervals = {
        year: 31536000,
        month: 2592000,
        week: 604800,
        day: 86400,
        hour: 3600,
        minute: 60,
        second: 1,
      };
      let counter;
      for (const i in intervals) {
        counter = Math.floor(seconds / intervals[i]);
        if (counter > 0) {
          if (counter === 1) {
            return `${counter} ${i} ago`; // singular (1 day ago)
          }
          return `${counter} ${i}s ago`; // plural (2 days ago)
        }
      }
    }
    return value;
  }
}
